<template>
  <div class="hello">

    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="Name" prop="name">
        <el-input v-model="form.name" maxlength="10" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="Medicine" prop="medicine">
        <el-select v-model="form.medicine" placeholder="please select medicine" >
          <el-option v-for="item in medicineOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">Submit</el-button>
        <el-button @click="resetForm('form')">Cancel</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>



<script>
import $ from 'jquery';
export default {
  name: 'ClertSubmit',
  data() {
      return {
        getMedicineListApi: 'https://yc.suyizaixian.com:30005/getDrugList',
        clerkSubmitApi: 'https://yc.suyizaixian.com:30005/onPostRequest',
        form: {
          name: '',
          medicine: '',
        },
        medicineOptions: [
          //{'label': 'aaa', 'value': 'aaa'},
          //{'label': 'bbb', 'value': 'bbb'},
        ],
        rules: {
          name: [
            { required: true, message: '请输入患者姓名', trigger: 'blur' },
            { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
          ],
          medicine: [
            { required: true, message: '请选择药品名字', trigger: 'change' }
          ],
        }
      }
    },
  props: {
    msg: String,
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        let _this = this;

          if (valid) {
            let datas = {
              customName: _this.form.name,
              drugId: _this.form.medicine,
              authToken: sessionStorage.getItem("authToken")
              };
            console.log(datas)
            $.ajax({
              type: 'POST',
              url: _this.clerkSubmitApi,
              data: datas
            }).then(res => {
              alert(JSON.stringify(res));
            }).catch((e) => { alert(e+"，登录超时，请重新登录");});
            //this.axios({
            //  method: "POST",
            //  url: _this.clerkSubmitApi,
            //  data: JSON.stringify(datas),
            //  headers:{
            //  'Content-Type':'application/x-www-form-urlencoded'
            //  }
            //})
            //.then(res=>{
            //    console.log('res=>',res);
            //})


          } else {
            alert('error submit!!');
            return false;
          }
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted () {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      this.$router.replace("/Login");
    }else{
    var __this = this;
    this.axios.get(__this.getMedicineListApi, {
      params: {
        authToken: sessionStorage.getItem("authToken")}
        }).then(function(res) {
        var data = res.data;
        console.log(data)
        for(var item of data){
          __this.medicineOptions.push({
            label: item.pillName,
            value: item.id
          });
        }
    }).catch((e) => { alert(e+"，登录超时，请重新登录");});
  }
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
